import { render, staticRenderFns } from "./ModalContentPostDelete.vue?vue&type=template&id=39733634&scoped=true&"
import script from "./ModalContentPostDelete.vue?vue&type=script&lang=js&"
export * from "./ModalContentPostDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39733634",
  null
  
)

export default component.exports